import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/home';

export default function HotMovies() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">精选全网热门<strong>免费电影</strong>和<strong>免费电视剧</strong></p>
          </div>
          <Link
            to="/category/movies"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotMovies.map((movie) => (
            <Link
              key={movie.id}
              to={`/article/${movie.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[2/3] rounded-xl overflow-hidden bg-background-200 mb-3">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                  title={`${movie.title} - 高清免费在线观看`}
                  loading="lazy"
                />
                <div className="absolute top-2 right-2 bg-background-950/80 backdrop-blur-sm text-accent-400 text-xs font-semibold px-2 py-1 rounded-md flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  {movie.rating}
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <span className="text-xs text-white/80 bg-primary-500/90 px-2 py-0.5 rounded-full whitespace-nowrap">
                    {movie.categoryName}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {movie.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-1">{movie.description}</p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/movies"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部热门内容 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}